import { combineReducers } from 'redux';
import adminReducer from './Admin.reducer';
import filesReducer from './Files.reducer';
import masterReducer from './Master.reducer';
import feedbackReducer from './Feedback.reducer';
import doctorReducer from './Doctor.reducer';
import accountReducer from './Account.reducer';
import imageReducer from './Images.reducer';
import reportreducer from './Report.reducer';
import settingreducer from './Setting.reducer';

const rootReducers = combineReducers({
    admin: adminReducer,
    files: filesReducer,
    master: masterReducer,
    feedback: feedbackReducer,
    doctor: doctorReducer,
    account: accountReducer,
    image: imageReducer,
    report: reportreducer,
    setting: settingreducer
})

export default rootReducers;